import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent implements OnInit {
  title: string;
  description: string;
  cancelText = 'Cancel';
  confirmText = 'Confirm';

  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.title = this.data.title;
    this.description = this.data.description;

    if (this.data.cancelText) {
      this.cancelText = this.data.cancelText;
    }
    if (this.data.confirmText) {
      this.confirmText = this.data.confirmText;
    }
  }

  cancel() {
    this.dialogRef.close({code: 0});
  }

  confirm() {
    this.dialogRef.close({code: 1});
  }

}
